<template>
  <div class="loginOrReg">
    <van-nav-bar left-arrow @click-left="$router.back()">
      <template #left>
        <van-icon name="arrow-left" />
        <span class="logo"></span>
      </template>
    </van-nav-bar>

    <div class="px-4 mt-[22px] relative">
      <div @click="loginOrReg" class="absolute-[0_0_auto] h-[150px]"></div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  const router = useRouter()
  const loginOrReg = (e: MouseEvent) => {
    const edge = window.innerWidth / 2
    const link = e.clientX < edge ? '/login' : '/reg'
    router.push(link)
  }
</script>

<style lang="scss" scoped>
  .loginOrReg {
    --van-nav-bar-background: transparent;
    --van-nav-bar-icon-color: #FFFFFF;
    --van-border-width: 0;

    .logo {
      @apply w-[118px] h-[26px] bgs-[url('@/assets/logo.png')] ml-3;
    }
  }
</style>
